import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useCallback, useContext } from 'react';
import classnames from 'classnames';
import { SafeAnchor } from '../SafeAnchor';
import SelectableContext, { makeEventKey } from '../SelectableContext';
import NavContext from './NavContext';
export const NavItem = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { className, children, active: propActive, disabled, style, onSelect, onClick, eventKey, role: propRole, id: propId, status, ...rest } = props;
    const navKey = makeEventKey(eventKey, props.href);
    const parentOnSelect = useContext(SelectableContext);
    const navContext = useContext(NavContext);
    const extraProps = {};
    let active = propActive;
    let role = propRole;
    let id = propId;
    if (navContext) {
        if (!propRole && navContext.role === 'tablist') role = 'tab';
        const contextControllerId = navContext.getControllerId(navKey);
        const contextControlledId = navContext.getControlledId(navKey);
        active = propActive == null && navKey != null ? makeEventKey(navContext.activeKey) === navKey : propActive;
        id = contextControllerId || id;
        extraProps['aria-controls'] = contextControlledId || props['aria-controls'];
    }
    const handleClick = useCallback((e)=>{
        if (disabled) {
            e.preventDefault();
            return;
        }
        if (onClick) onClick(e);
        // eslint-disable-next-line eqeqeq
        if (navKey == null) return;
        if (onSelect) onSelect(navKey, e);
        if (parentOnSelect) parentOnSelect(navKey, e);
    }, [
        disabled,
        navKey,
        onClick,
        onSelect,
        eventKey
    ]);
    const bsClassLink = classnames('nav-link', className, status && `tab-status-${status}`, {
        active
    }, {
        disabled
    });
    const bsClassNavItem = classnames('nav-item', {
        active
    });
    if (role === 'tab') {
        extraProps['aria-selected'] = active;
    }
    if (active) {
        extraProps['aria-current'] = 'page';
    }
    if (disabled) {
        extraProps['aria-disabled'] = true;
        extraProps['tabIndex'] = -1;
    }
    return /*#__PURE__*/ _jsxs("li", {
        className: bsClassNavItem,
        style: style,
        role: "presentation",
        children: [
            /*#__PURE__*/ _jsx(SafeAnchor, {
                ...rest,
                ...extraProps,
                id: id,
                disabled: disabled,
                ref: ref,
                role: role,
                className: bsClassLink,
                onClick: handleClick,
                children: children
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "tab-spillover"
            })
        ]
    });
});
NavItem.displayName = 'NavItem';
